import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'
import styles from './styles.module.scss'
import navStyles from '@shared/components/commonNav/style.module.scss'

function Partnership({ graphData, is100 }) {
  const pillsData = []
  graphData.sort(function(a, b) {
    return a.nInningNumber - b.nInningNumber
  })
  graphData.forEach((item, index) =>
    pillsData.push(
      {
        value: item.sName,
        label: `${item?.bSuperOver ? item.sName.replace('Inning', 'Super Over') : item.sName.replace('Inning', '')}`,
        score: `${item?.nRuns}/${item?.nWickets} (${is100 ? `${item?.sBalls}` : `${item?.sOvers}ov`})`
      }))
  const [activeTab, setActiveTab] = useState(pillsData[0].label)
  const inningsData = []

  graphData.forEach((data) =>
    inningsData.push(data.aPartnership)
  )

  const selectedIndex = pillsData.findIndex(function(ele) {
    return ele.label === activeTab
  })

  const data = inningsData[selectedIndex].map((ele) => {
    return (
      <div key={ele.nOrder} className={styles.root}>
        <div className={styles.container}>
          <span>
            <div>
              {ele.aBatsmen[0].oBatter.sShortName || '-'}
            </div>
            <div>
              {`${ele.aBatsmen[0].nRuns} (${ele.aBatsmen[0].nBallFaced}) `}
            </div>
          </span>
        </div>

        <div className='d-flex flex-column justify-content-center'>
          <div className='text-center'>
            {`${ele.nRuns} (${ele.nBallFaced})`}
          </div>
          <div className={`${styles.bar} row`}>
            <div className='col-6 justify-content-end'>
              <div className={styles.barWidth}
                style={{
                  width: `${ele?.aBatsmen[0]?.nRuns}px`,
                  background: '#F25824',
                  height: '100%'
                }}>
              </div>
            </div>
            <div className='col-6'>
              <div className={styles.barWidth}
                style={{
                  width: `${ele?.aBatsmen[1]?.nRuns}px`,
                  background: '#252775',
                  height: '100%'
                }}>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.container}>
          <span className='text-end'>
            <div>
              {ele.aBatsmen[1].oBatter.sShortName || '-'}
            </div>
            <div>
              {`${ele.aBatsmen[1].nRuns} (${ele.aBatsmen[1].nBallFaced})`}
            </div>
          </span>
        </div>
      </div>
    )
  })

  return (
    <div className='common-box pb-4'>
      <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} ${styles.pillsNav} justify-content-right`} variant="pills">
        {
          pillsData.map((type) => {
            return (
              <>
                <Nav.Item className={`${navStyles.item} ${styles.item}`}>
                  <a
                    className={`${activeTab === type.label && navStyles.active} nav-link`}
                    onClick={() => setActiveTab(type?.label)}
                  >
                    <div className="d-flex justify-content-between align-items-center flex-grow-1">
                      {type?.label} {type?.score}
                    </div>
                  </a>
                </Nav.Item>
              </>
            )
          })
        }
      </Nav>
      {data}
    </div>
  )
}

Partnership.propTypes = {
  graphData: PropTypes.array,
  is100: PropTypes.bool
}

export default Partnership
